import { Stack } from 'expo-router';

const SCREEN_OPTIONS = {
  headerShown: false,
  gestureEnabled: false
};

export default function AuthLayout() {
  return (
    <Stack screenOptions={SCREEN_OPTIONS}>
      <Stack.Screen name="maybe-onboard" />
      <Stack.Screen name="login" options={SCREEN_OPTIONS} />
      <Stack.Screen name="onboard" options={SCREEN_OPTIONS} />
      <Stack.Screen
        name="verify"
        options={{
          headerShown: true,
          headerTitle: '',
          headerBackTitle: 'Back'
        }}
      />
    </Stack>
  );
}
